/**
 * Cookie session auth paths — must match ApiService auth paths.
 * Declared here so URL policy can live outside ApiService and avoid HttpClient ↔ interceptor cycles.
 */
export const AUTH_WEB_REFRESH_PATH = '/usermgmt/auth/web/refresh';
export const AUTH_WEB_HANDOFF_PATH = '/usermgmt/auth/web/handoff';
export const AUTH_WEB_LOGOUT_PATH = '/usermgmt/logoutUser';
